<template>
    <el-dialog
            title="参加车展"
            :visible.sync="joinCarShowDialogVisible"
            width="30%">
        <el-form ref="form" label-width="120px">
            <el-form-item label="选择参展：">
                <car-show-select ref="car-show-select" @change="onCarShowChanged" style="width:300px;"></car-show-select>
                <p style="color:red;">同一个商家只能同时参加一场车展</p>
                <p style="color:red;">如果想要从车展中移除商家，清空选项保存即可</p>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="joinCarShowDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="commit()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import CarShowSelect from '@/components/CarShowSelect'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  name: 'join-car-show-dialog',
  components: {
    CarShowSelect
  },
  data () {
    return {
      joinCarShowDialogVisible: false,
      businessId: null,
      carShowId: null
    }
  },
  methods: {
    commit () {
      let params = {
        businessId: this.businessId,
        carShowId: this.carShowId
      }
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            message: '操作成功',
            type: 'success'
          })

          _this.$emit('onSuccess')
          _this.hideDialog()
        }
      }
      BasicModel.post(_this, 'lcwpbusiness/bindCarShowToBusiness.action', params, listener)
    },
    onCarShowChanged (carShowId) {
      this.carShowId = carShowId
    },
    showDialog (businessId, carShowId, carShowName) {
      this.businessId = businessId
      this.joinCarShowDialogVisible = true
      this.carShowId = carShowId

      this.$nextTick(() => {
        this.$refs['car-show-select'].clear()
        if (carShowId != null && carShowName != null) {
          this.$refs['car-show-select'].settingDefaultSelectInfo({ id: carShowId, name: carShowName })
        }
      })
    },
    hideDialog () {
      this.joinCarShowDialogVisible = false
    }
  }
}

</script>
